var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "mt-3 mb-2 elevation-2",
    attrs: {
      headers: _vm.headers,
      items: _vm.activitiesFilter,
      page: _vm.pagination.page,
      "items-per-page": _vm.paginationActivitiesTable.rowsPerPage,
      "items-per-page-text": _vm.$t("tables.RowsPerPage"),
      "header-props": { sortIcon: "mdi-menu-down" },
      "footer-props": {
        prevIcon: "mdi-menu-left",
        nextIcon: "mdi-menu-right",
        "items-per-page-options": _vm.rowsPerPageItems
      },
      loading: _vm.loading,
      "loading-text": ""
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationActivitiesTable, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationActivitiesTable, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableActivitiesTableId,
          _vm.paginationActivitiesTable.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                on: {
                  click: function($event) {
                    return _vm.openActivity(props.item)
                  }
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("activity-task-status-icon", {
                      attrs: {
                        status: props.item.state,
                        delayed: _vm.isDelayed(props.item)
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.title))]),
                _vm._v(" "),
                _c(
                  "td",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", "align-center": "" } },
                      [
                        _vm.getCreatorType(props.item.user_creator_id) !== ""
                          ? _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { small: "", color: "accent" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getCreatorType(
                                        props.item.user_creator_id
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getUserName(props.item.user_creator_id))
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFormattedDate(props.item.due_date)) +
                      "\n      "
                  )
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b3d6794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b3d6794","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivitiesTable.vue
// module id = null
// module chunks = 